<template>
    <div>
        <div class="content-caption dashed">
            <span>合同信息</span>
        </div>
        <div class="simple-form flex col-3">
            <div class="form-group center">
                <div class="form-label">
                    <label>零售商名称</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{ contract.fstPartyName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>服务商</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{ contract.sndPartyName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>合同名称</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{ contract.title }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>系统合同编号</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{ contract.no }}</span>
                </div>
            </div>
            <!--<div class="form-group center">
                <div class="form-label">
                    <label>自用合同编号</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{ contract.fstPartyHtBh }}</span>
                </div>
            </div>-->
        </div>
        <div class="simple-form flex col-3">
            <div class="form-group center">
                <div class="form-label">
                    <label>起始时间</label>
                </div>
                <div class="form-value width-2x">
                    <el-date-picker class="width-2x" :disabled="true" v-model="contract.dateStart" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">结束时间</label>
                </div>
                <div class="form-value width-2x">
                    <el-date-picker @change="checkTime" class="width-2x" v-model="contract.dateEnd" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label :class="normalFlag ? 'required' : ''">税率(%)</label>
                </div>
                <div class="form-value width-2x">
                    <el-select v-if="normalFlag" v-model="contract.taxRate" filterable placeholder="请选择税率" @change="taxRateChange(contract.taxRate)">
                        <el-option v-for="item in fiscalTaxMarkList" :key="item.rate" :label="item.rate" :value="item.rate"></el-option>
                    </el-select>
                    <el-input v-if="!normalFlag" class="width-2x" v-model="contract.taxRate" @change="taxRateChange(contract.taxRate)"></el-input>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>发票信息</span>
            <span class="swb-btn swb-btn-link" @click="selectInvoiceSubject">常用发票</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">发票类型</label>
                </div>
                <div class="form-value width-2x">
                    <ul class="enum-list">
                        <li class="enum-item" :class="{checked : (merchantInvoiceType.value == contract.invoiceType)}" v-for="merchantInvoiceType in invoiceTypeList" @click="checkInvoiceType(merchantInvoiceType.value)">
                            {{ merchantInvoiceType.text }}<i></i>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发票抬头</label>
                </div>
                <div class="form-value width-2x">
                    <el-input v-model="contract.invoiceTitle"></el-input>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发票内容标签</label>
                </div>
                <div class="form-value width-2x mt5">
                    <ul class="enum-list">
                        <li class="enum-item" v-bind:class="{checked : invoiceContentTag.name == contract.invoiceContentTag}" v-for="invoiceContentTag in invoiceContentTagList" @click="checkinvoiceContentTag(invoiceContentTag.name)">
                            {{ invoiceContentTag.name }}<i></i>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">纳税人识别号</label>
                </div>
                <div class="form-value width-2x">
                    <el-input v-model="contract.taxPayerNo"></el-input>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>适用机构(必选)</span>
            <span class="swb-btn swb-btn-link" @click="selectAppliedShop">选择</span>
        </div>
        <el-tag class="mr5" v-for="(contractAppliedShop, index) in contract.contractAppliedShopList" :key="contractAppliedShop.shopName" :closable="contractAppliedShop.id == null" type="info" @close="deleteAppliedShop(index)">
            <span>{{ contractAppliedShop.shopName }}</span>
        </el-tag>

        <div class="content-caption dashed">
            <span>设备维保服务</span>
        </div>
        <div class="table-layout" style="overflow:auto">
            <el-form :model="contract" ref="contractServcList">
                <table class="custom-tbl error-prompt">
                    <thead class="head">
                    <tr class="row">
                        <th width="200" class="text-align: left;">设备维保分组</th>
                        <th width="150" class="text-align: left;">资产品牌</th>
                        <th width="150" class="text-align: left;">服务类型</th>
                        <th width="150" class="text-align: left;">商品分类</th>
                        <th width="200" class="text-align: left;">服务内容</th>
                        <th width="80" class="text-align: left;">仅部件报修</th>
                        <th width="300" class="text-align: left;">设备部件</th>
                        <th width="200" class="text-align: left;">服务项目</th>
                        <th width="140" class="text-align: right;">上门费(元)</th>
                        <th width="140" class="text-align: right;">服务费(元)</th>
                        <th width="140" class="text-align: right;">要求响应时长(分钟)</th>
                        <th width="140" class="text-align: right;">要求到达时长(分钟)</th>
                        <th width="140" class="text-align: right;">要求维修时长(分钟)</th>
                        <th width="120" class="text-align: right;">要求质保时长(天)</th>
                        <th width="140" class="text-align: right;">电话回询时限(分钟)</th>
                        <th width="200" class="text-align: right;">服务次数</th>
                        <th width="200" class="text-align: left;">操作</th>
                    </tr>
                    </thead>
                    <tbody class="body">
                    <tr v-for="(item,index) in contract.contractServcList" class="row">
                        <td>
                            <span class="fl">{{ item.devcGroupFullName || '' }}</span>
                        </td>
                        <td>
                            <span class="fl">{{ item.innerDevcBrandName || '' }}</span>
                        </td>
                        <td>
                            <el-select v-model="item.servcTypeId" :disabled="true">
                                <el-option v-for="servcType in servcTypeList" :key="servcType.value" :label="servcType.text" :value="servcType.value"></el-option>
                            </el-select>
                        </td>
                        <td>
                            <span class="fl">{{ item.goodsCatName || '' }}</span>
                        </td>
                        <td>
                            <span class="fl">{{ item.servcSpec || '' }}</span>
                        </td>
                        <td>
                            <span class="fl">{{ item.devcPartsOnly || '' }}</span>
                        </td>
                        <td>
                            <span class="fl">{{ item.devcParts || '' }}</span>
                        </td>
                        <td>
                            <span class="fl">{{ item.title || '' }}</span>
                        </td>
                        <td>
                            <el-input type="number" :min="0" v-model="item.toDoorFee" v-if="checkActionPerm('view_item_price')" :disabled="true"></el-input>
                            <el-input v-else disabled type="text" value="没有权限"></el-input>
                        </td>
                        <td>
                            <el-input type="number" :min="0" v-model="item.price" v-if="checkActionPerm('view_item_price')" :disabled="true"></el-input>
                            <el-input v-else disabled type="text" value="没有权限"></el-input>
                        </td>
                        <td>
                            <el-input type="number" :min="0" v-model.number="item.rspTimeMi" :disabled="true"></el-input>
                        </td>
                        <td>
                            <el-input type="number" :min="0" v-model.number="item.arriveTimeMi" :disabled="true"></el-input>
                        </td>
                        <td>
                            <el-input type="number" :min="0" v-model.number="item.repairedTimeMi" :disabled="true"></el-input>
                        </td>
                        <td>
                            <el-input type="number" :min="0" v-model.number="item.wrntPeriod" :disabled="true"></el-input>
                        </td>
                        <td>
                            <el-input type="number" :min="0" v-model.number="item.telCallTimeMi" :disabled="true"></el-input>
                        </td>
                        <td>
                            <el-select v-model="item.timesLimitType" :disabled="true">
                                <el-option v-for="timesLimitType in timesLimitTypeList" :key="timesLimitType.value" :label="timesLimitType.text" :value="timesLimitType.value"></el-option>
                            </el-select>
                            <template v-if="item.timesLimitType == 0">
                                <el-form-item :prop="'contractServcList.' + index + '.quantity'" :rules="{validator: quantityCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model.number="item.quantity" @change="quantityChange(index, false)" :disabled="!item.quantityRevisible"></el-input>
                                </el-form-item>
                            </template>
                        </td>
                        <td>
                            <!--<div @click="setOrgPrice(index, false);" class="swb-btn swb-btn-link">-->
                            <!--<span>特定门店价格</span>-->
                            <!--</div>-->
                            <!--<div @click="setOrgQuantity(index, false);" class="swb-btn swb-btn-link" v-if="item.timesLimitType == 1">-->
                            <!--<span>门店服务次数</span>-->
                            <!--</div>-->
                            <div @click="setOrgSpecInfo(index, item.servcTypeId, item.timesLimitType, item.quantityRevisible, false);" class="swb-btn swb-btn-link">
                                <!-- 【保养，检验，巡检】+ 按门店设定次数： 可设定总价-->
                                <span>{{ item.timesLimitType != 1 ? '设置特定门店价格' : '设置门店次数和价格' }}</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-form>
        </div>
        <div class="content-caption dashed">
            <span>常规服务请求</span>
        </div>
        <div class="table-layout" style="overflow:auto">
            <el-form :model="contract" ref="contractServc2List">
                <table class="custom-tbl error-prompt">
                    <thead class="head">
                    <tr class="row">
                        <th width="150" class="text-align: left;">服务类型</th>
                        <th width="200" class="text-align: left;">常规服务需求</th>
                        <th width="200" class="text-align: left;">服务内容</th>
                        <th width="200" class="text-align: left;">服务项目</th>
                        <th width="140" class="text-align: right;">上门费(元)</th>
                        <th width="140" class="text-align: right;">服务费(元)</th>
                        <th width="140" class="text-align: right;">要求响应时长(分钟)</th>
                        <th width="140" class="text-align: right;">要求到达时长(分钟)</th>
                        <th width="140" class="text-align: right;">要求维修时长(分钟)</th>
                        <th width="120" class="text-align: right;">要求质保时长(天)</th>
                        <th width="140" class="text-align: right;">电话回询时限(分钟)</th>
                        <th width="200" class="text-align: right;">服务次数</th>
                        <th width="150">操作</th>
                    </tr>
                    </thead>
                    <tbody class="body">
                    <tr v-for="(item,index) in contract.contractServc2List" class="row">
                        <td>
                            <el-select v-model="item.servcTypeId" :disabled="true">
                                <el-option v-for="servcType in servcTypeList" :key="servcType.value" :label="servcType.text" :value="servcType.value"></el-option>
                            </el-select>
                        </td>
                        <td>
                            <span class="fl">{{ item.comnRequireTitle || '' }}</span>
                        </td>
                        <td>
                            <el-input type="textarea" :rows="2" v-model="item.servcSpec" :disabled="true"></el-input>
                        </td>
                        <td>
                            <span class="fl">{{ item.title || '' }}</span>
                        </td>
                        <td>
                            <el-input type="number" :min="0" v-model="item.toDoorFee" v-if="checkActionPerm('view_item_price')" :disabled="true"></el-input>
                            <el-input v-else disabled type="text" value="没有权限"></el-input>
                        </td>
                        <td>
                            <el-input type="number" :min="0" v-model="item.price" v-if="checkActionPerm('view_item_price')" :disabled="true"></el-input>
                            <el-input v-else disabled type="text" value="没有权限"></el-input>
                        </td>
                        <td>
                            <el-input type="number" :min="0" v-model.number="item.rspTimeMi" :disabled="true"></el-input>
                        </td>
                        <td>
                            <el-input type="number" :min="0" v-model.number="item.arriveTimeMi" :disabled="true"></el-input>
                        </td>
                        <td>
                            <el-input type="number" :min="0" v-model.number="item.repairedTimeMi" :disabled="true"></el-input>
                        </td>
                        <td>
                            <el-input type="number" :min="0" v-model.number="item.wrntPeriod" :disabled="true"></el-input>
                        </td>
                        <td>
                            <el-input type="number" :min="0" v-model.number="item.telCallTimeMi" :disabled="true"></el-input>
                        </td>
                        <td>
                            <el-select v-model="item.timesLimitType" :disabled="true">
                                <el-option v-for="timesLimitType in timesLimitTypeList" :disabled="true" :key="timesLimitType.value" :label="timesLimitType.text" :value="timesLimitType.value"></el-option>
                            </el-select>
                            <template v-if="item.timesLimitType == 0">
                                <el-form-item :prop="'contractServc2List.' + index + '.quantity'" :rules="{validator: quantityCheck, trigger: 'blur'}">
                                    <el-input type="number" :min="0" v-model.number="item.quantity" @change="quantityChange(index, true)" :disabled="!item.quantityRevisible"></el-input>
                                </el-form-item>
                            </template>
                        </td>
                        <td>
                            <!--<div @click="setOrgPrice(index, true);" class="swb-btn swb-btn-link">-->
                            <!--<span>特定门店价格</span>-->
                            <!--</div>-->
                            <!--<div @click="setOrgQuantity(index, true);" class="swb-btn swb-btn-link" v-if="item.timesLimitType == 1">-->
                            <!--<span>门店服务次数</span>-->
                            <!--</div>-->
                            <div @click="setOrgSpecInfo(index, item.servcTypeId, item.timesLimitType, item.quantityRevisible, true);" class="swb-btn swb-btn-link">
                                <!-- 【保养，检验，巡检】+ 按门店设定次数： 可设定总价-->
                                <span>{{ item.timesLimitType != 1 ? '设置特定门店价格' : '设置门店次数和价格' }}</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-form>
        </div>

    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {checkUserActionPerm} from '../index'
    import {openRetailerComListForSelectDlg} from '../retailer/selectDlg';
    import {openContractServcOrgPriceSetDlg, openContractServcOrgQuantitySetDlg, openContractServcOrgSpecListDlg} from './dialog';
    //
    import contractApi from '../../api/contract'

    import SwbServcPurchContractList from './ServcPurchContractList';
    import {getMerchantBizParam} from '../asset/assetMain';
    import fiscalBizApi from '../../api/fiscalBiz';
    import {selectInvoiceSubjectDlg} from '../invoiceVoucher/selectDlg';
    import merchtComnApi from '../../api/merchtComn';
    import merchtFinacApi from '../../api/merchtFinac';

    Routes.add(SwbServcPurchContractList);

    export default {
        name: 'swb-contract-servc-purch-modify',
        desc: '服务合同 - 修订',
        props: {
            id: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                contract: {},
                dbContract: {},
                //
                servcTypeList: getEnumList('servcType') || [],
                timesLimitTypeList: getEnumList('timesLimitType') || [],
                normalFlag: false,
                fiscalTaxMarkList: [],
                invoiceTypeList: [],
                invoiceContentTagList: [],
                servcPurch: getEnumInfoWith('contractType', 'name', 'ServcPurch')
            }
        },
        created: function () {
            // 发票类型
            let invoiceTypeList = getEnumList('invoiceType');
            for (let i = 0; i < invoiceTypeList.length; i++) {
                let invoiceType = invoiceTypeList[i];
                if (invoiceType.value == 0 || invoiceType.value == 3) {
                    invoiceTypeList.splice(i, 1);
                    i--;
                }
            }
            this.invoiceTypeList = Utils.merge([], invoiceTypeList);
            this.getContract();
            this.getFiscalTaxMarkList();
        },
        methods: {
            quantityCheck: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空!'));
                } else {
                    if (Utils.isNaturalStr(value, true) && value >= 0) {
                        callback();
                    } else {
                        callback(new Error('必须为大于等于0的整数!'));
                    }
                }
            },
            checkTime: function () {
                let self = this;
                let contract = self.contract;
                if (!Utils.isNoB(contract.dateStart) && !Utils.isNoB(contract.dateEnd)) {
                    // 判断时间大小
                    let dateStart = contract.dateStart.format("yyyy-MM-dd");
                    let dateEnd = contract.dateEnd.format("yyyy-MM-dd");
                    if (dateStart >= dateEnd) {
                        MsgBox.warning("请输入有效的合同开始结束时间");
                        return false;
                    }
                    let currentDate = new Date().format("yyyy-MM-dd");
                    if (dateEnd <= currentDate) {
                        MsgBox.warning("结束时间需大于今天");
                        return false;
                    }
                }
            },
            checkActionPerm: function (action) {
                return checkUserActionPerm(SwbServcPurchContractList.path, action, null);
            },
            // 获取合同信息
            getContract: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                let theLoad = MsgBox.loading();
                contractApi.getContractInfo(postData, function (result) {
                    theLoad.hide();
                    if (result.type == "info") {
                        let contract = result.data;
                        // 保留原数量，控制只可增加不可减少
                        let contractServcList = contract.contractServcList || [];
                        if (contractServcList.length > 0) {
                            for (let i = 0; i < contractServcList.length; i++) {
                                let contractServc = contractServcList[i];
                                contractServc.srcQuantity = contractServc.quantity
                            }
                        }
                        let contractServc2List = contract.contractServc2List || [];
                        if (contractServc2List.length > 0) {
                            for (let i = 0; i < contractServc2List.length; i++) {
                                let contractServc = contractServc2List[i];
                                contractServc.srcQuantity = contractServc.quantity
                            }
                        }
                        //
                        self.contract = Utils.merge({}, contract);
                        self.dbContract = Utils.merge({}, contract);
                        if (contract.kindId == 0) {
                            // 标准合同获取对应的实体公司的业务参数
                            getMerchantBizParam('asset.finac.enabled', function (normalFlagResult) {
                                self.normalFlag = Utils.isTrue(normalFlagResult);
                            }, 2, null, contract.fstPartyRealComId);
                        } else {
                            getMerchantBizParam('finac.mgmt.enabled', function (normalFlagResult) {
                                self.normalFlag = Utils.isTrue(normalFlagResult);
                            }, 0);
                        }
                        self.getInvoiceContentTagList();
                    }
                });
            },
            // 选择适用机构
            selectAppliedShop: function () {
                let self = this;
                let contract = self.contract || {};
                let realComId = contract.fstPartyRealComId;
                if (Utils.isNoB(realComId) || realComId <= 0) {
                    MsgBox.warning("请选择买方公司");
                    return;
                }
                let contractAppliedShopList = contract.contractAppliedShopList || [];
                let shopIds = [];
                if (contractAppliedShopList.length > 0) {
                    shopIds = contractAppliedShopList.pluck("shopId") || [];
                }
                let queryFilter = {
                    disabledIds: shopIds,
                    realComId: realComId,
                    signGroupId: contract.signGroupId,
                    orgType: getEnumInfoWith('orgType', 'name', 'BizUnit').value,
                    filterMerchantId: contract.kindId == 0
                };
                if (Utils.isNoB(realComId)) {
                    queryFilter.comLevel = 1;
                    queryFilter.comId = self.scopeEntity.comId1;
                }
                openRetailerComListForSelectDlg(queryFilter, function (comList, theDlg) {
                    theDlg.close();
                    let contractServcList = contract.contractServcList || [];
                    let contractServc2List = contract.contractServc2List || [];
                    for (let i = 0; i < comList.length; i++) {
                        let comInfo = comList[i];
                        let contractAppliedShop = {
                            shopId: comInfo.id,
                            shopName: comInfo.name,
                            shopLevel: comInfo.level,
                            shopFlag: comInfo.shopFlag,
                            bizAreaId: comInfo.bizAreaId,
                            bizAreaName: comInfo.bizAreaName,
                            bizFormId: comInfo.bizFormId,
                            bizFormName: comInfo.bizFormName,
                            mgmtSmlAreaId: comInfo.mgmtSmlAreaId,
                            mgmtSmlAreaName: comInfo.mgmtSmlAreaName,
                        };
                        contractAppliedShopList.push(contractAppliedShop);
                        // 检查并补充特定门店价格、特定服务次数信息。支持次数的才新增。
                        self.makeServcOrgSpecForQuantity(comInfo, contractServcList, contractServc2List);
                    }
                    contract.contractAppliedShopList = Utils.merge([], contractAppliedShopList);
                    self.contract = Utils.merge({}, contract);
                });
            },
            // 检查并补充特定门店价格、特定服务次数信息。支持次数的才新增。
            makeServcOrgSpecForQuantity: function (comInfo, contractServcList, contractServc2List) {
                let self = this;
                if (contractServcList.length > 0) {
                    for (let j = 0; j < contractServcList.length; j++) {
                        let contractServc = contractServcList[j];
                        if (contractServc.timesLimitType == 1) {  //按机构限定次数
                            let servcOrgSpecList = contractServc.servcOrgSpecList || [];
                            let bizUnitIds = [];
                            if (servcOrgSpecList.length > 0) {
                                bizUnitIds = servcOrgSpecList.pluck("bizUnitId");
                            }
                            if (bizUnitIds.indexOf(comInfo.id) < 0) {
                                servcOrgSpecList.push({
                                    bizUnitId: comInfo.id,
                                    bizUnitName: comInfo.name,
                                    shopFlag: comInfo.shopFlag,
                                    bizAreaId: comInfo.bizAreaId,
                                    bizAreaName: comInfo.bizAreaName,
                                    bizFormId: comInfo.bizFormId,
                                    bizFormName: comInfo.bizFormName,
                                    mgmtSmlAreaId: comInfo.mgmtSmlAreaId,
                                    mgmtSmlAreaName: comInfo.mgmtSmlAreaName,
                                    //
                                    priceSpecFlag: 0,
                                    price: 0.00,
                                    toDoorFee: 0.00,
                                    quantitySpecFlag: true,
                                    quantity: 0,
                                    srcQuantity: 0,
                                    amount: 0.00
                                });
                                contractServc.servcOrgSpecList = Utils.merge([], servcOrgSpecList);
                            }
                        }
                    }
                }
                if (contractServc2List.length > 0) {
                    for (let j = 0; j < contractServc2List.length; j++) {
                        let contractServc = contractServc2List[j];
                        if (contractServc.timesLimitType == 1) {  //按机构限定次数
                            let servcOrgSpecList = contractServc.servcOrgSpecList || [];
                            let bizUnitIds = [];
                            if (servcOrgSpecList.length > 0) {
                                bizUnitIds = servcOrgSpecList.pluck("bizUnitId");
                            }
                            if (bizUnitIds.indexOf(comInfo.id) < 0) {
                                servcOrgSpecList.push({
                                    bizUnitId: comInfo.id,
                                    bizUnitName: comInfo.name,
                                    shopFlag: comInfo.shopFlag,
                                    bizAreaId: comInfo.bizAreaId,
                                    bizAreaName: comInfo.bizAreaName,
                                    bizFormId: comInfo.bizFormId,
                                    bizFormName: comInfo.bizFormName,
                                    mgmtSmlAreaId: comInfo.mgmtSmlAreaId,
                                    mgmtSmlAreaName: comInfo.mgmtSmlAreaName,
                                    //
                                    priceSpecFlag: 0,
                                    price: 0.00,
                                    toDoorFee: 0.00,
                                    quantitySpecFlag: true,
                                    quantity: 0,
                                    srcQuantity: 0,
                                    amount: 0.00
                                });
                                contractServc.servcOrgSpecList = Utils.merge([], servcOrgSpecList);
                            }
                        }
                    }
                }
            },
            // 移除适用机构
            deleteAppliedShop: function (index) {
                let contract = this.contract || {};
                let contractAppliedShopList = contract.contractAppliedShopList || [];
                let removeAppliedShops = contractAppliedShopList.splice(index, 1);
                let removeAppliedShopInfo = removeAppliedShops[0];
                contract.contractAppliedShopList = Utils.merge([], contractAppliedShopList);
                // 处理-合同服务门店次数
                let contractServcList = contract.contractServcList || [];
                if (contractServcList.length > 0) {
                    for (let i = 0; i < contractServcList.length; i++) {
                        let contractServc = contractServcList[i];
                        if (contractServc.timesLimitType == 1) { // 按照门店
                            // 门店次数
                            let orgQuantityList = contractServc.orgQuantityList || [];
                            let length = orgQuantityList.length;
                            for (let j = 0; j < length; j++) {
                                let orgQuantity = orgQuantityList[j];
                                if (removeAppliedShopInfo.shopId == orgQuantity.bizUnitId) {
                                    contractServc.orgQuantityList.splice(j, 1);
                                    break;
                                }
                            }
                        }
                        // 门店价格
                        let lengthPrice = contractServc.orgPriceList.length;
                        for (let j = 0; j < lengthPrice; j++) {
                            let orgPrice = contractServc.orgPriceList[j];
                            if (removeAppliedShopInfo.shopId == orgPrice.bizUnitId) {
                                contractServc.orgPriceList.splice(j, 1);
                                break;
                            }
                        }
                    }
                    contract.contractServcList = Utils.merge([], contractServcList);
                }
                // 处理-合同服务门店次数
                let contractServc2List = contract.contractServc2List || [];
                if (contractServc2List.length > 0) {
                    for (let i = 0; i < contractServc2List.length; i++) {
                        let contractServc = contractServc2List[i];
                        if (contractServc.timesLimitType == 1) { // 按照门店
                            // 门店次数
                            let length = contractServc.orgQuantityList.length;
                            for (let j = 0; j < length; j++) {
                                let orgQuantity = contractServc.orgQuantityList[j];
                                if (removeAppliedShopInfo.shopId == orgQuantity.bizUnitId) {
                                    contractServc.orgQuantityList.splice(j, 1);
                                    break;
                                }
                            }
                        }
                        // 门店价格
                        let lengthPrice = contractServc.orgPriceList.length;
                        for (let j = 0; j < lengthPrice; j++) {
                            let orgPrice = contractServc.orgPriceList[j];
                            if (removeAppliedShopInfo.shopId == orgPrice.bizUnitId) {
                                contractServc.orgPriceList.splice(j, 1);
                                break;
                            }
                        }
                    }
                    contract.contractServc2List = Utils.merge([], contractServc2List);
                }
                this.contract = Utils.merge({}, contract);
            },
            // 服务次数变化事件
            quantityChange: function (index, comnRequire) {
                let contract = this.contract;
                let contractServc = {};
                if (Utils.isTrue(comnRequire)) {
                    // 常规服务请求
                    let contractServc2List = contract.contractServc2List || [];
                    contractServc = contractServc2List[index];
                } else {
                    // 设备维保服务
                    let contractServcList = contract.contractServcList || [];
                    contractServc = contractServcList[index];
                }
                if (contractServc.quantity < contractServc.srcQuantity) {
                    contractServc.quantity = contractServc.srcQuantity;
                    MsgBox.warning("不可小于当前数量");
                }
                this.contract = Utils.merge({}, contract);
            },
            // 设置特定门店价格
            setOrgPrice: function (index, comnRequire) {
                let self = this;
                let contract = this.contract || {};
                let contractAppliedShopList = contract.contractAppliedShopList || [];
                if (contractAppliedShopList.length <= 0) {
                    MsgBox.warning("请先选择适用机构");
                    return false;
                }
                let contractServc = {}
                if (comnRequire) {
                    contractServc = contract.contractServc2List[index] || {};
                } else {
                    contractServc = contract.contractServcList[index] || {};
                }
                let params = {
                    servcModify: true,
                    servcPrice: contractServc.price || 0.00,
                    orgPriceList: contractServc.orgPriceList || [],
                    contractAppliedShopList: contractAppliedShopList,
                    filterMerchantId: contract.kindId == 0
                }
                openContractServcOrgPriceSetDlg(params, function (orgPriceList) {
                    contractServc.orgPriceList = Utils.merge([], orgPriceList);
                    //
                    if (comnRequire) {
                        contract.contractServc2List[index] = Utils.merge({}, contractServc);
                    } else {
                        contract.contractServcList[index] = Utils.merge({}, contractServc);
                    }
                    self.contract = Utils.merge({}, contract);
                });
            },
            // 设置门店服务次数
            setOrgQuantity: function (index, comnRequire) {
                let self = this
                let contract = this.contract || {};
                let contractServc = {};
                if (comnRequire) {
                    contractServc = contract.contractServc2List[index] || {};
                } else {
                    contractServc = contract.contractServcList[index] || {};
                }
                if (contractServc.orgQuantityList.length <= 0) {
                    MsgBox.warning("请先选择适用机构");
                    return false;
                }
                let params = {
                    quantityRevisible: contractServc.quantityRevisible || false,
                    servcModify: true,
                    orgQuantityList: Utils.merge([], contractServc.orgQuantityList)
                }
                openContractServcOrgQuantitySetDlg(params, function (orgQuantityList) {
                    contractServc.orgQuantityList = Utils.merge([], orgQuantityList);
                    //
                    self.contract = Utils.merge({}, contract);
                });
            },
            // 设置服务特定
            setOrgSpecInfo: function (index, servcType, timesLimitType, quantityRevisible, comnRequire) {
                let self = this;
                let contract = this.contract || {};
                let contractAppliedShopList = contract.contractAppliedShopList || [];
                if (contractAppliedShopList.length <= 0) {
                    MsgBox.warning('请先选择适用机构');
                    return false;
                }
                let contractServc = {};
                if (comnRequire) {
                    contractServc = contract.contractServc2List[index] || {};
                } else {
                    contractServc = contract.contractServcList[index] || {};
                }
                let quantityFlag = timesLimitType == 1;     // 按门店设定次数：可设定服务次数。
                let amountFlag = timesLimitType == 1 && (servcType == 1 || servcType == 3 || servcType == 6);   // 【保养，检验，巡检】+ 按门店设定次数： 可设定总价
                let params = {
                    servcModify: true,
                    comnRequire: comnRequire,
                    quantityFlag: quantityFlag,
                    amountFlag: amountFlag,
                    quantityRevisible: quantityRevisible,
                    servcOrgSpecList: contractServc.servcOrgSpecList || [],
                    contractAppliedShopList: contractAppliedShopList,
                    filterMerchantId: contract.kindId == 0,
                    title: timesLimitType != 1 ? '设置特定门店价格' : '设置门店次数和价格',
                };
                openContractServcOrgSpecListDlg(params, function (servcOrgSpecList) {
                    contractServc.servcOrgSpecList = Utils.merge([], servcOrgSpecList);
                    //
                    if (comnRequire) {
                        contract.contractServc2List[index] = Utils.merge({}, contractServc);
                    } else {
                        contract.contractServcList[index] = Utils.merge({}, contractServc);
                    }
                    self.contract = Utils.merge({}, contract);
                });
            },
            getFiscalTaxMarkList: function () {
                let self = this;
                let postData = {};
                postData.disabled = false;
                postData.type = getEnumInfoWith('taxType', 'name', 'JXS').value;
                postData.sysBizLineId = 2;  // 服务税码
                let theLoad = MsgBox.loading();
                fiscalBizApi.getFiscalTaxMarkPageList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === 'info') {
                        let fiscalTaxMarkList = result.data || [];
                        if (fiscalTaxMarkList.length > 0) {
                            fiscalTaxMarkList.forEach(function (item) {
                                item.rate = parseFloat(item.rate).toFixed(2)
                            })
                        }
                        self.fiscalTaxMarkList = fiscalTaxMarkList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 税率变化事件
            taxRateChange: function (taxRate) {
                if (!Utils.isNoB(taxRate)) {
                    if (!Utils.isMoneyStr(taxRate)) {
                        taxRate = null;
                    } else {
                        let taxRateF = parseFloat(taxRate);
                        if (taxRateF > 100) {
                            taxRate = null;
                        } else {
                            taxRate = taxRateF.toFixed(2);
                        }
                    }
                }
                //
                let contract = this.contract || {};
                contract.taxRate = taxRate;
                this.contract = Utils.merge({}, contract);
            },
            // 常用发票
            selectInvoiceSubject: function () {
                let self = this;
                if (Utils.isNoB(self.contract.invoiceType)) {
                    MsgBox.warning('未确定发票类型');
                    return;
                }
                let params = {
                    showAddFlag: true,
                    buyerRealComId: self.contract.fstPartyRealComId,
                    invoiceType: self.contract.invoiceType
                };
                selectInvoiceSubjectDlg(params, function (resultData, theDlag) {
                    theDlag.close();
                    self.contract.invoiceTitle = resultData.invoiceTitle;
                    self.contract.taxPayerNo = resultData.taxPayerNo;
                    //self.contract.invoiceContentTag = data.invoiceContentTag;
                    self.contract = Utils.merge({}, self.contract);
                })
            },
            checkInvoiceType: function (value) {
                this.contract.invoiceType = value;
                if (!Utils.isNoB(value) && !Utils.isNoB(this.contract.fstPartyRealComId)) {
                    this.getTaxOffSetVal(value);
                }
                //
                this.getMerchantInvoiceSubjectByOnly();
            },
            getTaxOffSetVal: function (invoiceType) {
                let self = this;
                let params = {
                    invoiceType: invoiceType,
                    realComId: self.contract.fstPartyRealComId
                };
                merchtComnApi.getTaxDeductible(params, function (result) {
                    if (result.type == 'info') {
                        let data = result.data;
                        //
                        let contract = self.contract || {};
                        contract.taxOffset = Utils.isTrue(data);
                        //
                        self.contract = Utils.merge({}, contract);
                    }
                });
            },
            getMerchantInvoiceSubjectByOnly: function () {
                let self = this;
                let postData = {};
                postData.realComId = self.contract.fstPartyRealComId;
                postData.invoiceType = self.contract.invoiceType;
                merchtFinacApi.getMerchantInvoiceSubjectList(postData, function (result) {
                    if (result.type == 'info') {
                        let invoiceSubjectList = Utils.merge([], result.data);
                        if (invoiceSubjectList.length > 0) {
                            let invoiceSubjectInfo = null;
                            for (let i = 0; i < invoiceSubjectList.length; i++) {
                                if (Utils.isTrue(invoiceSubjectList[i].defaulted)) {
                                    invoiceSubjectInfo = invoiceSubjectList[i];
                                    break;
                                }
                            }
                            self.contract.invoiceTitle = invoiceSubjectInfo.invoiceTitle;
                            self.contract.taxPayerNo = invoiceSubjectInfo.taxPayerNo;
                            //self.contract.invoiceContentTag = data.invoiceContentTag;
                            self.contract = Utils.merge({}, self.contract);
                        } else {
                            self.contract.invoiceTitle = null;
                            self.contract.taxPayerNo = null;
                            //self.contract.invoiceContentTag = null;
                            self.contract = Utils.merge({}, self.contract);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getInvoiceContentTagList: function () {
                let self = this;
                let postData = {};
                postData.merchantRealId = self.contract.sndPartyRealId;
                postData.realComId = self.contract.sndPartyRealComId;
                postData.merchantType = self.servcPurch.sndPartyType;
                merchtFinacApi.getMerchantInvoiceCtntTagList(postData, function (result) {
                    if (result.type == 'info') {
                        if (result.data != null && result.data.length > 0) {
                            self.invoiceContentTagList = result.data;
                        }
                    }
                });
            },
            checkinvoiceContentTag: function (name) {
                let self = this;
                self.contract.invoiceContentTag = name;
            },
            //
            getDlgResult: function () {
                let self = this;
                let result = {
                    type: 'warn'
                };
                let contract = this.contract || {};
                let dateStart = contract.dateStart.format("yyyy-MM-dd");
                let dateEnd = contract.dateEnd.format("yyyy-MM-dd");
                if (dateStart >= dateEnd) {
                    result.message = "请输入有效的合同开始结束时间";
                    return result;
                }
                let currentDate = new Date().format("yyyy-MM-dd");
                if (dateEnd <= currentDate) {
                    result.message = "结束时间需大于今天";
                    return result;
                }
                if (Utils.isTrue(this.normalFlag)) {
                    if (Utils.isNoB(contract.taxRate)) {
                        result.message = "请输入税率，大于等于0的数！";
                        return result;
                    } else {
                        if (!Utils.isMoneyStr(contract.taxRate)) {
                            result.message = "请输入正确的税率！";
                            return result;
                        } else {
                            let taxRate = parseFloat(contract.taxRate);
                            if (taxRate > 100) {
                                result.message = "税率不能超过100！";
                                return result;
                            }
                        }
                    }
                }
                if (Utils.isNoB(contract.invoiceType)) {
                    result.message = "发票信息[发票类型]不可为空";
                    return result;
                }
                if (Utils.isNoB(contract.taxPayerNo)) {
                    result.message = "发票信息[纳税人识别号]不可为空";
                    return result;
                }
                //
                result.type = "info";
                result.data = Utils.merge({}, contract);
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractServcPurchModify.vue